import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import NewsModal from "./components/NewsModal";
import CookieBanner from "./components/CookieBanner";
import Analytics from "./components/Analytics";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import Wechseljahre from "./pages/Wechseljahre";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import AdminLayout from "./pages/AdminLayout";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminForgot from "./pages/AdminForgot";
import { useLocation } from "react-router-dom";
import { PraxisProvider } from "./context/PraxisContext";

function LayoutFrame({ children }) {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");
  return (
    <>
      {!isAdmin && <Header />}
      <main id="main">{children}</main>
      {!isAdmin && <Footer />}
      {!isAdmin && <CookieBanner />}
      {!isAdmin && <NewsModal />}
      {!isAdmin && <Analytics />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <PraxisProvider>
          <ScrollToTop />
          <a href="#main" className="skip-link">Zum Hauptinhalt springen</a>
          <LayoutFrame>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/wechseljahre" element={<Wechseljahre />} />
              <Route path="/impressum" element={<Impressum />} />
              <Route path="/datenschutz" element={<Datenschutz />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/forgot" element={<AdminForgot />} />
              <Route element={<AdminLayout />}>
                <Route path="/admin" element={<AdminDashboard />} />
              </Route>
              <Route path="*" element={<Home />} />
            </Routes>
          </LayoutFrame>
        </PraxisProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
